import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import state from '@/store/state'
import actions from './actions'
import getters from './getters'

import mutations from './mutations'

Vue.use(Vuex)

// Configure vuex-persistent-state
const persistantStateOptions = {
  key: 'PMP_STATE',
  paths: ['session']
}

export default new Vuex.Store({
  plugins: [createPersistedState(persistantStateOptions)],
  actions,
  getters,
  mutations,
  state
})
